import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, loading, user, authError } = useAuth();
  const location = useLocation();

  // Log para debug
  console.log('🔄 AdminRoute check:', { 
    isAuthenticated, 
    loading, 
    userEmail: user?.email, 
    userType: user?.userType,
    pathname: location.pathname
  });

  // Se ainda está carregando, mostrar loading
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f8fafc'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '16px'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #e5e7eb',
            borderTop: '4px solid #3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <p style={{ color: '#64748b', margin: 0 }}>Verificando permissões...</p>
        </div>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  // Se não está autenticado, redirecionar para login
  if (!isAuthenticated || !user) {
    console.log('❌ Usuário não autenticado, redirecionando para login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Se não é admin, redirecionar para área apropriada
  if (user.userType !== 'admin') {
    console.log('🚨 Usuário não é admin, redirecionando...');
    
    if (user.userType === 'student') {
      // Se é aluno, redirecionar para área do aluno
      console.log('🎓 Redirecionando aluno para /aluno');
      return <Navigate to="/aluno" replace />;
    } else {
      // Se é outro tipo, redirecionar para home
      console.log('👤 Redirecionando usuário para home');
      return <Navigate to="/" replace />;
    }
  }

  // Se é admin, verificar se é school_adm tentando acessar dashboard
  if (user.userType === 'admin' && user.profile?.school_adm && location.pathname === '/') {
    console.log('🏫 School admin tentando acessar dashboard, redirecionando para /alunos');
    return <Navigate to="/alunos" replace />;
  }

  // Se é admin, permitir acesso
  console.log('✅ Usuário admin autenticado, permitindo acesso');
  return children;
};

export default AdminRoute;
